import Vue from 'vue';
import VueRouter from 'vue-router';
import spaRoutes from './routes';
import main from '@/main';
import customRoutes from '@/custom/router.js';
import ticket from '@/views/ticket/index.vue';
Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    redirect: '/saas/articleManagement.html',
  },
  ...spaRoutes,
  ...customRoutes,
  {
    path: '/japi/qiye/oauth/ticket/:agentid/:redirecturl',
    name: 'ticket',
    component: ticket,
  },
  {
    path: '*',
    redirect: '/saas/articleManagement.html',
  },
];
// base:process.env.BASE_URL,
const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});
// router.beforeEach((to, from, next) => {
//   // 离开页面时记录定位
//   // from.meta.savedPosition = {
//   //   x: 0,
//   //   y: document.documentElement.scrollTop || document.body.scrollTop,
//   // };
//   // next();
// });

// 路由后置钩子
router.afterEach(() => {
  console.log('main', main);
  main.$store.commit('user/setBreadcrumb', []); // 路由切换，页面面包屑清除
});
export default router;
